import Component from '@glimmer/component';
import '../lib/utility/ajax.js';
import '@ember/object';
import '@ember/utils';
import 'moment-timezone';
import 'ember-inflector';
import '../lib/utility/province.js';
import { isReadableOn } from '../lib/utility/color-contrast.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{! template-lint-disable no-forbidden-elements }}\n<style>\n  {{~#if this.primaryColor~}}\n    html:not([data-theme=\'dark\']):root {\n    --color-clear-blue: {{this.primaryColor}};\n    --color-clear-blue-1: {{this.primaryColor}}85;\n    --color-clear-blue-2: {{this.primaryColor}}70;\n    --color-clear-blue-3: {{this.primaryColor}}55;\n    --color-clear-blue-4: {{this.primaryColor}}40;\n    --color-clear-blue-5: {{this.primaryColor}}35;\n    --color-clear-blue-6: {{this.primaryColor}}25;\n    --color-clear-blue-7: {{this.primaryColor}}15;\n    --color-clear-blue-8: {{this.primaryColor}}08;\n    }\n  {{~/if~}}\n  {{~#if this.darkSafePrimaryColor~}}\n    html[data-theme=\'dark\']:root {\n    --color-clear-blue: {{this.darkSafePrimaryColor}};\n    --color-clear-blue-1: {{this.darkSafePrimaryColor}}85;\n    --color-clear-blue-2: {{this.darkSafePrimaryColor}}70;\n    --color-clear-blue-3: {{this.darkSafePrimaryColor}}55;\n    --color-clear-blue-4: {{this.darkSafePrimaryColor}}40;\n    --color-clear-blue-5: {{this.darkSafePrimaryColor}}35;\n    --color-clear-blue-6: {{this.darkSafePrimaryColor}}25;\n    --color-clear-blue-7: {{this.darkSafePrimaryColor}}15;\n    --color-clear-blue-8: {{this.darkSafePrimaryColor}}08;\n    }\n  {{~/if~}}\n  {{~#if @secondaryColor~}}\n    :root:root {\n    --color-secondary: {{@secondaryColor}};\n    --color-secondary-1: {{@secondaryColor}}85;\n    --color-secondary-2: {{@secondaryColor}}70;\n    --color-secondary-3: {{@secondaryColor}}55;\n    --color-secondary-4: {{@secondaryColor}}40;\n    --color-secondary-5: {{@secondaryColor}}35;\n    --color-secondary-6: {{@secondaryColor}}25;\n    --color-secondary-7: {{@secondaryColor}}15;\n    --color-secondary-8: {{@secondaryColor}}08;\n    }\n  {{~/if~}}\n  {{~#if @secondaryTextColor~}}\n    :root:root { --color-secondary-text: {{@secondaryTextColor}}; }\n  {{~/if~}}\n</style>\n");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — emits the per-tenant brand palette as a <style>
 *              block, theme-scoped so an unreadable brand colour cannot follow
 *              the page into the dark theme
 *   extends:   Component (@glimmer/component)
 *   template:  bb-tenant-palette.hbs
 *   args:      primaryColor, secondaryColor, secondaryTextColor
 *   uses:      ../lib/utility (isReadableOn)
 *   siblings:  each host app's application.hbs, which renders this next to its
 *              own tenant rules (menu colours, .loading, tenant custom CSS)
 *   tests:     -
 *   gotchas:   selectors are theme-scoped on purpose. Plain `:root` (0,1,0)
 *              loses to the `html[data-theme='dark']` token block in
 *              _custom_variables.scss (0,1,1), which is how every tenant on the
 *              dark theme silently lost its brand colour; both blocks here are
 *              (0,2,1) and each matches only its own theme, so neither leaks.
 *              --color-secondary is NOT gated: the base stylesheet never
 *              defines it, so there is no default to fall back to.
 *
 * The dark gate is one-directional. Light is left exactly as it has always
 * been — the shipped light default (#11b1d2 on white) only reaches 2.55:1
 * itself, so any floor applied there would reject colours that look fine and
 * have shipped for years. Only the dark ground, which is what the theme
 * introduced, is checked.
 */
const DARK_GROUNDS = ['#1a1a1a', '#242424'];
class BbTenantPaletteComponent extends Component {
  get primaryColor() {
    return this.args.primaryColor || null;
  }

  /**
   * The brand colour, but only when it is still legible on the dark grounds.
   * Null lets the `html[data-theme='dark']` defaults in beebee-base stand.
   */
  get darkSafePrimaryColor() {
    const color = this.primaryColor;
    return color && isReadableOn(color, DARK_GROUNDS) ? color : null;
  }
}
setComponentTemplate(TEMPLATE, BbTenantPaletteComponent);

export { BbTenantPaletteComponent as default };
//# sourceMappingURL=bb-tenant-palette.js.map
